interface Plurals {
  [key: string]: string;
}

export const plurals: Plurals = {
  totalStrike: 'totalStrikes',
  significantStrike: 'significantStrikes',
  significantStrikeHead: 'significantStrikesHead',
  significantStrikeBody: 'significantStrikesBody',
  significantStrikeLegs: 'significantStrikesLegs',
  takedown: 'takedowns',
  takedownAttempt: 'takedownAttempts',
  takedownDefended: 'takedownsDefended',
  transition: 'transitions',
  submissionAttempt: 'submissionAttempts',
  knockdown: 'knockdowns',
  elapsedControlTime: 'Elapsed Control Time',
  controlStarted: 'controlStarted',
  controlEnded: 'controlEnded',
  roundStart: 'roundStart',
  roundEnd: 'roundEnd',
  fightEnd: 'fightEnd',
  fightStart: 'fightStart',
  nearFall: 'nearFalls',
  exposure: 'exposures',
  fall: 'falls',
  pinning: 'pinnings',
  role: 'roles',
  reversal: 'reversals',
  turnover: 'turnovers',
  counterattack: 'counterattacks',
  outOfBound: 'outOfBounds',
  escape: 'escapes',
  stalling: 'stallings',
  passivity: 'passivities',
  advantage: 'advantages',
  caution: 'cautions',
  backtake: 'backtakes',
  technicalViolation: 'technicalViolations',
  score: 'score',
  ridingTime: 'ridingTime',
  timeout: 'timeout',
  fightResult: 'fightResult',
  timeout_start: 'timeout_start',
  timeout_end: 'timeout_end',
  pointDeduction: 'pointsDeduction',
};

export default plurals;
